





































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { User, TeamReviewees } from "../../types";

@Component
export default class AutoComplete extends Vue {
  @Prop() private suggestions!: TeamReviewees[];
  @Prop() private selection!: TeamReviewees[];
  private selectionText: string[] = [];
  private isOpen = false;
  private results: TeamReviewees[] = [];
  private arrowCounter = -1;

  private mounted() {
    let tagsInput = document.getElementById("tags-basic") as HTMLInputElement;
    if (tagsInput) {
      tagsInput.addEventListener("focus", this.onFocusEvent);
      tagsInput.addEventListener("input", this.onFocusEvent);
    }
  }

  @Watch("selection", { immediate: true })
  private onSelectionChange() {
    this.selectionText = this.selection.map(selection => selection.name);
    this.clearInputTag();
  }

  private clearInputTag() {
    let tagsInput = document.getElementById("tags-basic") as HTMLInputElement;
    if (tagsInput) {
      tagsInput.value = "";
      tagsInput.dispatchEvent(new Event("input"));
    }
  }

  private onFocusEvent() {
    let tagsInput = document.getElementById("tags-basic") as HTMLInputElement;
    if (tagsInput && tagsInput.value.length === 0) {
      this.onChange("");
    }
  }

  private onChange(tag: string) {
    this.filterResults(tag);
    if (this.results && this.results.length > 0) {
      this.isOpen = true;
    } else {
      this.isOpen = false;
    }
    return true;
  }

  private filterResults(tag: String) {
    if (this.suggestions && this.suggestions.length > 0) {
      if (tag && tag.length > 0) {
        this.results = this.suggestions.filter(suggestions => {
          return suggestions.name.toLowerCase().indexOf(tag.toLowerCase()) > -1;
        });
      } else {
        this.results = this.suggestions.filter(suggestions => {
          return suggestions.name;
        });
      }
    }
  }
  private setResult(uid: string) {
    this.isOpen = false;
    this.$emit("selection", uid);
  }
  private onArrowDown(evt: any) {
    evt.preventDefault();
    if (this.arrowCounter < this.results.length - 1) {
      this.arrowCounter = this.arrowCounter + 1;
      this.fixScrolling();
    }
  }
  private onArrowUp(evt: any) {
    evt.preventDefault();
    if (this.arrowCounter > 0) {
      this.arrowCounter = this.arrowCounter - 1;
      this.fixScrolling();
    }
  }
  private fixScrolling() {
    const optionsList = this.$refs.options as Element[];
    const liH = optionsList[this.arrowCounter].clientHeight;
    const scrollContainer = this.$refs.scrollContainer as Element;
    scrollContainer.scrollTop = liH * this.arrowCounter;
  }
  private onEnter() {
    if (this.arrowCounter > -1) {
      this.isOpen = false;
      this.$emit("selection", this.results[this.arrowCounter].uid);
      this.arrowCounter = -1;
    }
  }

  private handleClickOutside(evt: any) {
    if (!this.$el.contains(evt.target)) {
      this.isOpen = false;
      this.arrowCounter = -1;
    }
  }

  @Watch("selectionText")
  private onSelectionText(newVal: string[], oldVal: string[]) {
    if (newVal.length < oldVal.length) {
      var filtered = oldVal.filter(old => {
        return newVal.indexOf(old) === -1;
      });
      var index = oldVal.indexOf(filtered[0]);
      let uid = this.selection[index].uid;
      this.$emit("removed", uid);
    }
  }
}
